export default {
  setItems(state, items) {
    state.items = items;
  },
  setItem(state, item) {
    state.item = item;
  },
  setTotalItems(state, total) {
    state.totalItems = total;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setRegisterLoading(state, registerLoading) {
    state.registerLoading = registerLoading;
  },
  setOptions(state, options) {
    state.options = options;
  },
  patchOptions(state, options) {
    state.options = {
      ...state.options,
      ...options,
    };
  },
  setDeleteDialog(state, dialog) {
    state.deleteDialog = dialog;
  },
  setBulkDeleteDialog(state, dialog) {
    state.bulkDeleteDialog = dialog;
  },
  setBulkHideDialog(state, dialog) {
    state.bulkHideDialog = dialog;
  },
  setRegisterDialog(state, dialog) {
    state.registerDialog = dialog;
  },
  setSegmentos(state, segmentos) {
    state.segmentos = segmentos;
  },
  setDeleteItem(state, item) {
    state.deleteItem = item;
  },
  setBulkDeleteItems(state, items) {
    state.bulkDeleteItems = items;
  },
  setBulkHideItems(state, items) {
    state.bulkHideItems = items;
  },
  setBlockDialog(state, dialog) {
    state.blockDialog = dialog;
  },
  setBlockItem(state, item) {
    state.blockItem = item;
  },
  setShowTable(state, showTable) {
    state.showTable = showTable;
  },
  setCollection(state, collection) {
    state.collection = collection;
  },
  setCollections(state, collections) {
    state.collections = collections;
  },
  setSearchType(state, searchType) {
    state.searchType = searchType;
  },
  patchRegisterAccount(state, $event) {
    state.registerAccount = {
      ...state.registerAccount,
      ...$event,
    };
  },
  setSuportes(state, suportes) {
    state.suportes = suportes;
  },
  setIdiomas(state, idiomas) {
    state.idiomas = idiomas;
  },
  patchFilter(state, $event) {
    state.filter = {
      ...state.filter,
      ...$event,
    };
  },
  setFilter(state, filter) {
    state.filter = { ...filter };
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setGlobalSearch(state, globalSearch) {
    state.globalSearch = globalSearch;
  },
};
